import {gql} from "@apollo/client";

export const GET_GUIDES_LIST = gql`
    query getGuidesList {
        getGuidesList {
            _id
            email
            profile {
                _id
                firstName
                lastName
                languages
            }
            tourLabel {
                _id
                title {
                    _id
                    title
                }
                price
            }
        }
    }
`;

export const ADD_GUIDE = gql`
    mutation addGuide($guideInput: GuideInput!) {
        addGuide(guideInput: $guideInput)
    }
`;

export const UPDATE_GUIDE = gql`
    mutation updateGuide($guideInput: GuideInput!) {
        updateGuide(guideInput: $guideInput)
    }
`;

export const GET_AVAILABLE_GUIDES = gql`
    query getAvailableGuides ($bookingDateTime: Date) {
        getAvailableGuides (bookingDateTime: $bookingDateTime) {
            _id
            profile {
                firstName
                lastName
            }
        }
    }
`;

export const UPDATE_GUIDE_AVAILABILITY = gql`
    mutation updateGuideAvailability($availabilityInput: AvailabilityGuideInput!) {
        updateGuideAvailability(availabilityInput: $availabilityInput)
    }
`;

export const GET_AVAILABILITY = gql`
    query GetAvailability {
        getAvailability {
            _id
            guide
            monthYear
            schedule {
                day
                startTime
                endTime
            }
        }
    }
`;

export const GET_GUIDE_PROFILE = gql`
    query GetGuideProfile {
        getGuideProfile {
            _id
            firstName
            lastName
            languages
        }
    }
`;

export const REQUEST_PASSWORD_RESET = gql`
    mutation RequestPasswordReset($passwordResetInput: PasswordResetInput!) {
        requestPasswordReset(passwordResetInput: $passwordResetInput) 
    }
`;

